<template>
	<div class="box">
		<div class="header">
			<div class="header-text">最近一小时压力</div>
			<div class="header-time">{{nowHour+':00-'+nowHour+':59'}}</div>
		</div>
		<div class="day-chart">
			<div class="empty-data" v-show="hourData.length==0">暂无数据</div>
			<div class="chart-content">
				<div class="chart-main">
					<div class="text-tag">
						<div class="text-tag-aa">压力较大</div>
						<div class="text-tag-bb">稍有压力</div>
						<div class="text-tag-cc">放松</div>
					</div>
					<div class="chart-day">
						<div class="chart-day-main">
							<div class="bar" v-for="item in hourData" :key="item.time_str"
								:style="{backgroundColor:colorFilter(item.stress_index),height:2*item.stress_index+'px',left:leftFilter(item.time_str)}">
							</div>
						</div>
						<div class="point-line-a"></div>
						<div class="point-line-b"></div>
						<div class="mean-line" :style="{bottom:hourMean*2+'px'}" v-show="hourData.length!=0"></div>
						<div class="mean-point" :style="{bottom:hourMean*2-10+'px'}" v-show="hourData.length!=0">
							<!-- 平均{{hourMean}}</div> -->
							当前{{hourMean}}</div>
						<div>
							<div class="line-d"></div>
							<div class="line-e"></div>
							<div class="line-f"></div>
							<div class="line-dd"></div>
							<div class="line-ee"></div>
							<div class="line-ff"></div>
						</div>
						<div class="time-list-box">
							<div class="day-time-list">
								<div class="day-time-item">0</div>
								<div class="day-time-item">5</div>
								<div class="day-time-item">10</div>
								<div class="day-time-item">15</div>
								<div class="day-time-item">20</div>
								<div class="day-time-item">25</div>
								<div class="day-time-item">30</div>
								<div class="day-time-item">35</div>
								<div class="day-time-item">40</div>
								<div class="day-time-item">45</div>
								<div class="day-time-item">50</div>
								<div class="day-time-item">55</div>
								<div class="day-time-item">60</div>
							</div>
							<div class="minute-point">分</div>
						</div>
					</div>
					<div class="num-tag">
						<div class="num-tag-a">100</div>
						<div class="num-tag-b">70</div>
						<div class="num-tag-c">50</div>
						<!-- <div class="num-tag-d">0</div> -->
					</div>
				</div>
			</div>
		</div>
		<div class="index-item">
			<div class="index-header" style="display: flex;flex-direction: row;justify-content: space-between;">
				<div class="index-title">最近压力指数</div><div class="index-title">{{newDate}}</div>
			</div>
			<div class="index-content">
				<div class="low" v-if="!formatStress.stress.index">--</div>
				<div class="no-low" v-else>
					<div class="show-index">
						<img src="../assets/images/stress1.png" class="index-icn" v-if="stressIcn==1" />
						<img src="../assets/images/stress2.png" class="index-icn" v-if="stressIcn==2" />
						<img src="../assets/images/stress3.png" class="index-icn" v-if="stressIcn==3" />
						<div class="index-num" :style="stressColor">{{formatStress.stress.index}}</div>
					</div>
					<div class="index-text" :style="stressColor">您现在{{formatStress.stress.short_content}}</div>
				</div>
			</div>
		</div>
		<div class="index-item">
			<div class="index-header">
				<div class="index-title">压力解读</div>
			</div>
			<div class="index-content">
				<div class="no-unscramble" v-if="!formatStress.stress.index">暂无解读</div>
				<!-- <div class="unscramble" v-else v-html="formatStress.stress.long_content"></div> -->
				<div class="unscramble" v-else>
					<div style="text-indent: 2em;font-size: 18px;line-height: 32px;" v-for="(item,i) in formatStress.stress.long_content" :key="i">{{formatStress.stress.long_content[i]}}</div>
				</div>
			</div>
		</div>
		<div v-if="Object.keys(tuijian).length" class="index-item" style="margin-top: 20px;">
			<div class="recommend-content">
				<div class="recommend-title">
					<div style="padding: 0px 10px;">为你推荐</div>
					<div @click="toService" style="padding: 0px 10px;">查看更多></div>
				</div>
				<div class="recommend-title">
					<div style="padding: 0px 10px;">根据您当前的状态为您推荐下列内容：</div>
				</div>
				<div @click="toTrain(tuijian)" class="recommended-list">
					<div style="width: 130px;" class="recommended-item">
						<div class="thumbnail">
							<img :src="tuijian.icon_url" alt="" />
						</div>
					</div>
					<div class="recommended-item" style="text-indent: .5em;line-height: 45px;font-size: 14px;color: #a8a8a8;">
						<div style="height: 45px;overflow: hidden;color: #000;">{{tuijian.title}}</div>
						<div>白噪音  {{parseInt(tuijian.audio_duration/60)}}分钟</div>
					</div>
				</div>
			</div>
		</div>
		<div style="height: 20px;"></div>
	</div>
</template>
<script>
	import moment from 'moment';
	import {
		service_resource
	} from '../api/server'
	import {
		hour_identify,
		describe
	} from '../api/emotion'
	function randomRange(min, max) {
		return Math.floor(Math.random() * (max - min)) + min;
	}
	export default {
		data() {
			return {
				tuijian:{},
				newDate:'',
				imei: '',
				loginPhone: '',
				hourData: [],
				recently_data: {},
				startTime: 0,
				indicators_data: [],
				stressColor: '',
				stressIcn: 1,
				nowHour: '',
				hourMean: 0,
			};
		},
		computed: {
			formatStress() {
				let stress = {}
				
				// let stress = {
				// 	index: this.hourMean,
				// 	short_content:this.$route.query.short_content,
				// 	long_content:this.$route.query.long_content
				// }
				// return {stress};
				for (let i = 0; i < this.indicators_data.length; i++) {
					let item = this.indicators_data[i]
					if (item.dimension == 'stress') {
						if (this.hourMean >= item.min && this.hourMean <= item.max) {
							let sc = item.shorts.split('/')
							let short_content = sc[randomRange(0,sc.length)]
							let lc = JSON.parse(item.contents).data
							let long_content = lc[randomRange(0,lc.length)].split('-')
							stress = {
								index: this.hourMean,
								// short_content:this.$route.query.short_content,
								// long_content:this.$route.query.long_content,
								suggestion: item.suggestion,
								short_content,
								long_content
							}
						}
					}
				}
				return {
					stress
				}
			},
		},
		methods: {
			describeAll() {
				describe().then(res => {
					if (res.status == 200) {
						this.indicators_data = res.data.indicators
					} else {
						this.$toast('暂无数据');
					}
				})
			},
			hourIdentify() {
				hour_identify(this.imei, this.$route.query.time).then(res => {
					if (res.status == 200) {
						console.log(res)
						this.hourData = res.data.stressData
						this.startTime = res.data.startTime
						let hourAll = 0
						res.data.stressData.forEach(item => {
							hourAll += item.stress_index
						})
						let ln = res.data.stressData.length;
						this.hourMean = res.data.stressData[0].stress_index
						this.newDate = moment(res.data.stressData[0].time_str*1000).format('HH:mm')
						// this.hourMean = parseInt(hourAll / ln)
						if (this.hourMean >= 0 && this.hourMean <= 49) {
							this.stressColor = {
								color: '#55CF04'
							}
							this.stressIcn = 1
						}
						if (this.hourMean >= 50 && this.hourMean <= 69) {
							this.stressColor = {
								color: '#01D6D6'
							}
							this.stressIcn = 2
						}
						if (this.hourMean >= 70 && this.hourMean <= 100) {
							this.stressColor = {
								color: '#FF0036'
							}
							this.stressIcn = 3
						}
					}
					if (res.status == 400) {
						this.$toast.center('暂无数据');
					}
				})
			},
			colorFilter(num) {
				if (num <= 49) {
					return '#55CF04'
				}
				if (num >= 50 && num <= 69) {
					return '#01D6D6'
				}
				if (num >= 70 && num <= 100) {
					return '#FF0036'
				}
			},
			leftFilter(time) {
				// return (time - this.startTime) / 3600 * 240 - 5 + 'px'
				return (time - this.startTime) / 3600 * 240- ((time - this.startTime) / 3600)*10  + 'px'
			},
			toTrain(data){
				this.$router.replace({path:'/meditation-audio',query:data})
			},
			toService(){
				this.$router.replace('/service')
			},
			getContent() {
				let data = {
					target: "压力",
					level: "放松",
					timestamp: moment().format('YYYY-MM-DD HH:mm:ss')
				}
				let num = this.formatStress.stress.index;
				if(num>69){
					data.level = "压力较大"
				}else if(num>49){
					data.level = "稍有压力"
				}else{
					data.level = "放松"
				}
				service_resource(JSON.stringify(data), 'heartide.bixin.audio.calc').then(res => {
					if (res.code == '0') {
						let reslist = JSON.parse(res.data)
						if(reslist.length){
							this.tuijian = reslist[0]
						}
						console.log(this.resData)
					}
				}).catch(e => {
					console.log(e);
				})
			}
		},
		created() {
			let imei = localStorage.getItem('imei')
			this.imei = imei
			let phone = localStorage.getItem('phone')
			this.loginPhone = phone
			this.hourIdentify()
			this.describeAll()
			let date = new Date(this.$route.query.time * 1000)
			let hour = date.getHours()
			if (hour < 10) {
				hour = '0' + hour
			}
			this.nowHour = hour
		},
		mounted() {
			this.getContent();
		}
	};
</script>
<style lang='less' scoped>
	.box {
		padding: 0px 16px;
	}

	.header {
		height: 18px;
		padding-top: 20px;
		padding-bottom: 16px;
		display: flex;
		justify-content: space-between;
	}

	.header-text {
		height: 18px;
		line-height: 18px;
		font-size: 18px;
		font-weight: 500;
		color: #333;
	}

	.header-time {
		height: 148px;
		line-height: 14px;
		font-size: 14px;
		margin-top: 2px;
		color: #333;
	}

	.index-item {
		border-radius: 10px;
		/* margin-bottom: 10px; */
	}

	.index-header {
		background-color: #FBFCFC;
		border-radius: 10px 10px 0px 0px;
		height: 48px;
		padding: 0px 12px;
	}

	.index-title {
		height: 48px;
		line-height: 48px;
		font-size: 16px;
		font-weight: 500;
		color: #333;
	}

	.index-content {
		background-color: #fff;
		border-radius: 0px 0px 10px 10px;
	}

	.show-index {
		height: 32px;
		display: flex;
		justify-content: center;
		padding-top: 16px;
		padding-bottom: 12px;
	}

	.index-icn {
		height: 32px;
	}

	.index-num {
		height: 32px;
		line-height: 32px;
		font-size: 32px;
		font-weight: 900;
		margin-left: 10px;
		font-family: 'avenir';
	}

	.index-text {
		height: 14px;
		line-height: 14px;
		font-size: 14px;
		font-weight: 500;
		text-align: center;
		padding-bottom: 20px;
	}

	.unscramble {
		padding: 12px;
		line-height: 16px;
		color: #666666;
		font-size: 12px;
	}

	.day-chart {
		position: relative;
	}

	.chart-content {
		padding: 12px;
		background-color: #fff;
		border-radius: 10px;
		margin-bottom: 10px;
		padding-bottom: 40px;
	}

	.empty-data {
		position: absolute;
		width: 100%;
		height: 100%;
		line-height: 200px;
		text-align: center;
		color: #999999;
		font-size: 12px;
		font-weight: bolder;
		left: 0px;
		top: 0px;
		z-index: 10;
	}

	.chart-main {
		display: flex;
		justify-content: center;
	}

	.text-tag {
		height: 200px;
	}

	.text-tag-aa {
		height: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #FF0036;
		font-weight: 400;
		width: 24px;
		margin: 10px 0px;
	}

	.text-tag-bb {
		height: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #01D6D6;
		font-weight: 400;
		width: 24px;
	}

	.text-tag-cc {
		height: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #55CF04;
		font-weight: 400;
		width: 24px;
		margin: 30px 0px;
	}

	.chart-day {
		height: 200px;
		width: 248px;
		margin: 0px 5px;
		position: relative;
		background-color: #F5F8F8;
	}

	.chart-day-main {
		width: 240px;
		height: 200px;
		margin: 0 auto;
		position: relative;
	}

	.bar {
		width: 10px;
		border-radius: 3px 3px 0px 0px;
		position: absolute;
		bottom: 0px;
		z-index: 11;
	}

	.point-line-a {
		width: 100%;
		height: 1px;
		background-color: #E3E8E8;
		position: absolute;
		left: 0px;
		top: 60px;
	}

	.point-line-b {
		width: 100%;
		height: 1px;
		background-color: #E3E8E8;
		position: absolute;
		left: 0px;
		top: 100px;
	}

	.mean-line {
		width: 100%;
		height: 1px;
		border-bottom: 1px dashed #01D6D6;
		position: absolute;
		left: 0px;
		z-index: 8;
	}

	.mean-point {
		width: 40px;
		height: 20px;
		line-height: 20px;
		background: #01D6D6;
		border-radius: 3px;
		text-align: center;
		color: #fff;
		font-size: 12px;
		font-weight: 500;
		position: absolute;
		right: -47px;
		z-index: 8;
	}

	.line-d {
		height: 60px;
		width: 1px;
		position: absolute;
		top: 0px;
		left: 0px;
		background-color: #FF0036;
	}

	.line-e {
		height: 40px;
		width: 1px;
		position: absolute;
		top: 60px;
		left: 0px;
		background-color: #01D6D6;
	}

	.line-f {
		height: 100px;
		width: 1px;
		position: absolute;
		top: 100px;
		left: 0px;
		background-color: #55CF04;
	}

	.line-dd {
		height: 60px;
		width: 1px;
		position: absolute;
		top: 0px;
		right: 0px;
		background-color: #FF0036;
	}

	.line-ee {
		height: 40px;
		width: 1px;
		position: absolute;
		top: 60px;
		right: 0px;
		background-color: #01D6D6;
	}

	.line-ff {
		height: 100px;
		width: 1px;
		position: absolute;
		top: 100px;
		right: 0px;
		background-color: #55CF04;
	}

	.num-tag {
		height: 200px;
		position: relative;
		width: 20px;
	}

	.num-tag-a {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #333333;
		font-weight: 400;
		position: absolute;
		left: 0px;
		top: 0px;
	}

	.num-tag-b {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #333333;
		font-weight: 400;
		position: absolute;
		left: 0px;
		top: 50px;
	}

	.num-tag-c {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #333333;
		font-weight: 400;
		position: absolute;
		left: 0px;
		top: 90px;
	}

	.num-tag-d {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #333333;
		font-weight: 400;
		position: absolute;
		left: 0px;
		bottom: 0px;
	}

	.day-time-list {
		width: 240px;
		margin: 0 auto;
		height: 16px;
		display: flex;
		justify-content: space-between;
	}

	.day-time-item {
		min-width: 16px;
		height: 16px;
		line-height: 16px;
		font-size: 12px;
		color: #333333;
	}

	.low {
		height: 94px;
		line-height: 94px;
		font-size: 16px;
		font-weight: 600;
		color: #666;
		text-align: center;
	}

	.no-unscramble {
		height: 50px;
		line-height: 50px;
		text-align: center;
		color: #999;
		font-weight: bolder;
		font-size: 12px;
	}

	.time-list-box {
		position: absolute;
		left: 0px;
		bottom: -24px;
		width: 100%;
	}

	.minute-point {
		height: 16px;
		line-height: 16px;
		font-size: 12px;
		color: #333333;
		position: absolute;
		top: 0px;
		right: -16px;
	}
	.recommend-content {
		/* padding: 0px 12px; */
		background-color: #fff;
		border-radius: 0px 0px 10px 10px;
	}
	
	.recommend-title {
		line-height: 2vh;
		font-size: 14px;
		/* font-size: 1.4vh; */
		color: #333;
		padding: 12px 0px;
		display: flex;
		justify-content: space-between;
	}
	
	.recommended-list {
		display: flex;
		justify-content: space-between;
		padding: 10px;
		padding-bottom: 1.4vh;
	}
	
	.recommended-item {
		width: 48%;
	}
	
	.thumbnail {
		height: 12vh;
		width: 100%;
		border-radius: 10px;
		position: relative;
	}
	
	.thumbnail img {
		display: block;
		height: 12vh;
		width: 100%;
		border-radius: 10px;
	}
	
	.item-icn {
		height: 1.6vh;
		line-height: 1.6vh;
		width: 34px;
		text-align: center;
		font-size: 1.2vh;
	
		color: #fff;
		border-radius: 0px 10px 0px 10px;
		background-color: #55CF04;
		position: absolute;
		top: 0px;
		right: 0px;
	}
</style>
